module.exports = __webpack_public_path__ + "img/赛事管理办法@2x.fe8a3aef.png";